import Component from './NotFound';
export const NotFound = Component;
export default NotFound;
